import NewsMaster from '@features/shared/news/components/NewsMaster';
import { isNewsMasterActivated } from '@functions/featureFlag';
import CookieSettingsModal from '@settingsCookies/components/CookieSettingsModal';
import { FC } from 'react';

const GlobalModals: FC = () => {
	return (
		<>
			{isNewsMasterActivated() ? <NewsMaster /> : null}
			<CookieSettingsModal />
		</>
	);
};

export { GlobalModals };
